export default __webpack_public_path__ + "static/media/TataBanner.38e4b4c2.jpeg";